var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-493 -3435) translate(0 2581) translate(0 662) translate(375 192) translate(118.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.85 0h-8.1C3.023 0 0 3.023 0 6.75v8.1c0 3.727 3.023 6.75 6.75 6.75h8.1c3.727 0 6.75-3.023 6.75-6.75v-8.1C21.6 3.023 18.577 0 14.85 0zm4.725 14.85c0 2.606-2.12 4.725-4.725 4.725h-8.1c-2.605 0-4.725-2.12-4.725-4.725v-8.1c0-2.605 2.12-4.725 4.725-4.725h8.1c2.606 0 4.725 2.12 4.725 4.725v8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 5.4c-2.982 0-5.4 2.418-5.4 5.4s2.418 5.4 5.4 5.4 5.4-2.418 5.4-5.4-2.418-5.4-5.4-5.4zm0 8.775c-1.86 0-3.375-1.515-3.375-3.375 0-1.862 1.515-3.375 3.375-3.375s3.375 1.513 3.375 3.375c0 1.86-1.515 3.375-3.375 3.375z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.605,
    cy: 4.995,
    r: 1
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.78310e4e04efa318bb025e52a164537a.svg";
export { ForwardRef as ReactComponent };